import { BaseURL, extApiKey, getCountry} from '../environment/Environment';

const serviceURL = {
    BaseUrl : BaseURL,
    generateQR : '/v1/web-consent-manager/consents/qr',
    eventsQR : '/v1/consents/qr',
    countryUrl : getCountry,
    apiKey : extApiKey
}

export {serviceURL}